import React from 'react'

export const CheckoutPaymentCBReturnSuccess = () => {
    setTimeout(() => {
        window.parent.iframeSuccess()
    }, 100)

    return <div />
}
